import { Fragment } from "react";
import Link from "next/link";

/**
 * Shared breadcrumb trail, rendered ABOVE a page's own header (not inside any
 * nav bar), e.g. "My maps / <map name>" on the map detail page, or the
 * editor's working-area crumb. Server-safe; no client hooks.
 */
export function Breadcrumb({ items }: { items: Array<{ label: string; href?: string }> }) {
  return (
    <nav className="pz-breadcrumb" aria-label="Breadcrumb">
      {items.map((item, i) => {
        const isLast = i === items.length - 1;
        return (
          <Fragment key={`${item.label}-${i}`}>
            {i > 0 ? (
              <span className="pz-breadcrumb__sep" aria-hidden>
                /
              </span>
            ) : null}
            {isLast || !item.href ? (
              <span className="pz-breadcrumb__current" aria-current={isLast ? "page" : undefined}>
                {item.label}
              </span>
            ) : (
              <Link className="pz-breadcrumb__link" href={item.href}>
                {item.label}
              </Link>
            )}
          </Fragment>
        );
      })}
    </nav>
  );
}
